import { render } from "./PhotoAperture.vue?vue&type=template&id=6e35fd46&scoped=true"
import script from "./PhotoAperture.vue?vue&type=script&lang=js"
export * from "./PhotoAperture.vue?vue&type=script&lang=js"

import "./PhotoAperture.vue?vue&type=style&index=0&id=6e35fd46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e35fd46"]])

export default __exports__